export const AGENT = 'agent';
export const BROKER = 'broker';
export const TEAM = 'team';
export const FRANCHISOR = 'franchisor';
export const MLS = 'mls';
export const VENDOR_PARTNER = 'vendor_partner';
export const GETTING_CONNECT = 'Getting the Connect branded search app';
export const GETTING_SPACIO = 'Getting Spacio for open house lead generation';
export const GETTING_BOOST = 'Getting Boost for automated listing ads';
export const GETTING_HELP = 'Getting help';
export const PARTNERING_WITH_HOMESPOTTER = 'Partnering with HomeSpotter';
export const SHARING_A_COMMENT = 'Sharing a general comment';
export const CONTACT_US_FORM = 'Contact Us form';
export const DEMO_REQUEST_FORM = 'Demo Request form';

export const BUSINESS_OPTIONS = [
    { label: 'Agent', value: AGENT },
    { label: 'Broker', value: BROKER },
    { label: 'Team', value: TEAM },
    { label: 'Franchisor', value: FRANCHISOR },
    { label: 'MLS', value: MLS },
    { label: 'Vendor Partner', value: VENDOR_PARTNER },
];

export const CONTACT_US_BUSINESS_OPTIONS = [
    { label: 'Agent', value: AGENT },
    { label: 'Broker', value: BROKER },
    { label: 'Team', value: TEAM },
    { label: 'Franchisor', value: FRANCHISOR },
    { label: 'MLS', value: MLS },
];

export const AGENT_COUNT_OPTIONS = [
    { value: '1-9', label: '1-9' },
    { value: '10-99', label: '10-99' },
    { value: '100-299', label: '100-299' },
    { value: '300-499', label: '300-499' },
    { value: '500-999', label: '500-999' },
    { value: '1000+', label: '1000+' },
];

export const CONTACT_US_INTEREST_OPTIONS = [
    GETTING_CONNECT,
    GETTING_SPACIO,
    GETTING_BOOST,
    GETTING_HELP,
    PARTNERING_WITH_HOMESPOTTER,
    SHARING_A_COMMENT,
];

export const PRODUCT_NAME_CHECKBOXES = {
    boost: 'interested_in_boost',
    connect: 'interested_in_connect',
    spacio: 'interested_in_spacio',
};

export const CONTACT_US_INTEREST_CHECKBOXES_MAP = {
    [GETTING_CONNECT]: 'connect',
    [GETTING_SPACIO]: 'spacio',
    [GETTING_BOOST]: 'boost'
};

export const CONTACT_US_INTEREST_BUSINESS_MAP = {
    [PARTNERING_WITH_HOMESPOTTER]: VENDOR_PARTNER
};

export const INTERESTS_TO_PRODUCTS = {
    interested_in_boost: 'Boost',
    interested_in_connect: 'Connect',
    interested_in_spacio: 'Spacio'
}